// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__CYIUb","section":"Footer_section__6ErFO","bottomBorder":"Footer_bottomBorder__NKuNn"};